import React, { useId } from "react";
import PropTypes from "prop-types";

const paths = [
  "M10 13C10 12.4477 10.4477 12 11 12H16C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H11C10.4477 14 10 13.5523 10 13ZM7 13C7 12.4477 7.44772 12 8 12H8.00898C8.56127 12 9.00898 12.4477 9.00898 13C9.00898 13.5523 8.56127 14 8.00898 14H8C7.44772 14 7 13.5523 7 13ZM7 17C7 16.4477 7.44772 16 8 16H13C13.5523 16 14 16.4477 14 17C14 17.5523 13.5523 18 13 18H8C7.44772 18 7 17.5523 7 17ZM14.991 17C14.991 16.4477 15.4387 16 15.991 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H15.991C15.4387 18 14.991 17.5523 14.991 17Z",
  "M7 2C7 1.44772 6.55228 1 6 1C5.44772 1 5 1.44772 5 2V2.44885C5.38032 2.32821 5.78554 2.24208 6.21533 2.17961C6.46328 2.14357 6.72472 2.11476 7 2.09173V2Z",
  "M19 2.44885C18.6197 2.32821 18.2145 2.24208 17.7847 2.17961C17.5367 2.14357 17.2753 2.11476 17 2.09173V2C17 1.44772 17.4477 1 18 1C18.5523 1 19 1.44772 19 2V2.44885Z",
  "M13.0288 2H10.9712C9.02294 1.99997 7.45141 1.99994 6.21533 2.17961C4.92535 2.3671 3.8568 2.76781 3.01802 3.6746C2.18949 4.57031 1.83279 5.69272 1.66416 7.04866C1.49997 8.36894 1.49998 10.0541 1.5 12.1739V12.8261C1.49998 14.9459 1.49997 16.6311 1.66416 17.9513C1.83279 19.3073 2.18949 20.4297 3.01802 21.3254C3.8568 22.2322 4.92535 22.6329 6.21533 22.8204C7.45142 23.0001 9.02293 23 10.9712 23H13.0288C14.9771 23 16.5486 23.0001 17.7847 22.8204C19.0747 22.6329 20.1432 22.2322 20.982 21.3254C21.8105 20.4297 22.1672 19.3073 22.3358 17.9513C22.5 16.6311 22.5 14.9459 22.5 12.8261V12.1739C22.5 10.0541 22.5 8.36895 22.3358 7.04866C22.1672 5.69272 21.8105 4.57031 20.982 3.6746C20.1432 2.76781 19.0747 2.3671 17.7847 2.17961C16.5486 1.99994 14.9771 1.99997 13.0288 2ZM4.49783 9C4.03921 9 3.8099 9 3.66385 9.14417C3.51781 9.28833 3.51487 9.51472 3.509 9.96751C3.50027 10.6407 3.5 11.3942 3.5 12.2432V12.7568C3.5 14.9616 3.50182 16.5221 3.64887 17.7045C3.79327 18.8656 4.06263 19.5094 4.48622 19.9673C4.89956 20.4142 5.4647 20.6903 6.503 20.8412C7.57858 20.9975 9.00425 21 11.05 21H12.95C14.9957 21 16.4214 20.9975 17.497 20.8412C18.5353 20.6903 19.1004 20.4142 19.5138 19.9673C19.9374 19.5094 20.2067 18.8656 20.3511 17.7045C20.4982 16.5221 20.5 14.9616 20.5 12.7568V12.2432C20.5 11.3942 20.4997 10.6407 20.491 9.96751C20.4851 9.51472 20.4822 9.28833 20.3362 9.14417C20.1901 9 19.9608 9 19.5022 9H4.49783Z",
];

const gradients = [
  { x1: "16.3077", y1: "13.2321", x2: "12.2904", y2: "20.1293" },
  { x1: "18.0308", y1: "1.29753", x2: "17.8089", y2: "3.50575" },
  { x1: "18.0308", y1: "1.29753", x2: "17.8089", y2: "3.50575" },
  { x1: "21.0462", y1: "6.31248", x2: "4.88856", y2: "22.9568" },
];

const EventsIcon = ({
  selected,
  width,
  height,
  className,
  ...props
}) => {
  const id = useId().replace(/:/g, "");
  const isActive = selected;
  const gradientIds = paths.map((_, index) => `events-gradient-${index}-${id}`);

  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g opacity={isActive ? undefined : "0.5"}>
        {paths.map((path, index) => (
          <path
            key={path}
            fillRule={index === 0 || index === 3 ? "evenodd" : undefined}
            clipRule={index === 0 || index === 3 ? "evenodd" : undefined}
            d={path}
            fill={`url(#${gradientIds[index]})`}
          />
        ))}
      </g>
      <defs>
        {gradientIds.map((gradientId, index) => (
          <linearGradient
            key={gradientId}
            id={gradientId}
            {...gradients[index]}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D946EF" />
            <stop offset="1" stopColor="#67E8F9" />
          </linearGradient>
        ))}
      </defs>
    </svg>
  );
};

EventsIcon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

EventsIcon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default EventsIcon;
